export interface ForemanEmployeeListItem {
  employeeID: string;
  firstName: string;
  lastName: string;
  last4SSN: string;
  displayName: string;
  laborCount: number;
  text?: string;
}
